<template>
    <div id="success-send-mail">
        <modal-box :open="openModalBox" @close="openModalBox = false">
            
            <h2 class="mb-0" slot="header">
                <slot name="header"></slot>
            </h2>

            <div class="text-center">
                <slot></slot>
            </div>

            <div class="d-flex justify-content-center align-items-center mt-4">
                <a 
                    @click="$emit('confirm'), openModalBox = false"
                    class="btn btn-sm btn-outline-primary text-uppercase cursor-pointer" >
                {{ __( 'cookies.Accept' ) }}
                </a>
            </div>
        </modal-box>
    </div>
</template>

<script>
export default {

    mounted() {

        if ( ! this.openModalBox ) {
            this.openModalBox = true;
        }

    },

    data() {
        return {
            openModalBox: false,
        }
    }

}
</script>

<style lang="scss">
    @import "./../../sass/variables";
    
    #success-send-mail {

        .modal-box article{
            min-width: 16rem;
            max-width: 26rem;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ModalAlert.vue